import PropTypes from 'prop-types';
import { Box, Typography } from '@material-ui/core';
import { Handle, Position } from 'reactflow';

import { useStyles } from './NodeStyles';
import { HopNodeTooltip } from './HopNodeTooltip';

export default function UnidentifiableHopNode({ data }) {
    const styles = useStyles();

    return (
        <Box className={styles.nodeWrapper}>
            <HopNodeTooltip nodeData={data}>
                <Box className={`${styles.node} ${styles.unidentifiableHopNode}`}>
                    <Handle type="source" position={Position.Right} isConnectable={false} />
                    <Handle type="target" position={Position.Left} isConnectable={false} />
                </Box>
            </HopNodeTooltip>
            {(data.hopData.statusMessage || data.isUnidentifiableGroup) && (
                <Box className={`${styles.hopNodeBottomContent} hop-node-bottom-content`}>
                    {data.hopData.statusMessage && (
                        <Typography variant="body1">{data.hopData.statusMessage}</Typography>
                    )}
                    {data.isUnidentifiableGroup && (
                        <Typography variant="body1">
                            {data.hopData.startHop} - {data.hopData.endHop}
                        </Typography>
                    )}
                </Box>
            )}
        </Box>
    );
}

UnidentifiableHopNode.propTypes = {
    // The data prop is passed through to the component by Reactflow
    data: PropTypes.object,
};

UnidentifiableHopNode.defaultProps = {
    data: {},
};
